var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"using-help"},[_c('van-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},_vm._l((_vm.questionsList),function(item,i){return _c('van-collapse-item',{key:i,attrs:{"title":item.q,"name":i}},[_c('div',{domProps:{"innerHTML":_vm._s(item.a)}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }